module.exports = __webpack_public_path__ + "img/article5_4.9c995e48.jpg";